import type { FavoritesList, FavoriteToggleResult } from "../types/favorite.dto";

/**
 * Favoritos — pelo BFF do app, NÃO pelo proxy `/api/nest`.
 *
 * A nest expõe `/customer/favorites/:cpfCnpj`; estas rotas resolvem o CPF do
 * cookie httpOnly no servidor, então ele nunca aparece na URL do browser (e
 * portanto nem no access log, nem no histórico, nem no header `Referer`).
 * Nenhum parâmetro de identidade sai daqui.
 */

const BASE = "/api/customer/favorites";

async function call<T>(path: string, init?: RequestInit): Promise<T> {
    const response = await fetch(`${BASE}${path}`, { ...init, cache: "no-store" });
    if (!response.ok) {
        const body = (await response.json().catch(() => null)) as { error?: string } | null;
        throw new Error(body?.error ?? "Não foi possível atualizar os favoritos.");
    }
    return (await response.json()) as T;
}

/** Lista completa (com os produtos) — painel do perfil e widget da home. */
export function getFavorites(): Promise<FavoritesList> {
    return call<FavoritesList>("");
}

/** TOGGLE no backend: remove se já for favorito. O retorno diz o que ficou. */
export function addFavorite(productId: number, storeId?: number): Promise<FavoriteToggleResult> {
    const query = storeId !== undefined ? `?storeId=${storeId}` : "";
    return call<FavoriteToggleResult>(`/${productId}${query}`, { method: "POST" });
}

/** TOGGLE no backend: adiciona se não for favorito. O retorno diz o que ficou. */
export function removeFavorite(productId: number): Promise<FavoriteToggleResult> {
    return call<FavoriteToggleResult>(`/${productId}`, { method: "DELETE" });
}
